import { NoteStepSchema } from '@feedyou/schema'

import { search } from './services/search'
import { useFormSchema, useFormUiSchema } from './services/hooks'
import { createStepService } from '../../utils/stepServices/createStepServices'

export const noteStepServices = createStepService<NoteStepSchema, {}>({
  search,

  useFormSchema,
  useFormUiSchema
})
